<template>

  <!-- activebtn-page start -->
  <div v-show="show_activebtnPage" id="activebtnPage" class="activebtn-page">
    <div class="activebtn-bottomsheet">
      <div class="activebtn-text-box">
        <span class="activebtn-text">服務已結束，如需再次對話</span>
        <span class="activebtn-text clickme-text" @click="activebtnPage_closeModal()">【請點我】</span>
      </div>
    </div>
  </div>
  <!-- activebtn-page end -->

</template>

<script>

export default {
  props: {
    show_activebtnPage: {
      type: Boolean,
      default: () => false
    },
    handle_show_activebtnPage: {
      type: Function,
      required: true
    }
  },
  methods: {
    activebtnPage_closeModal(){
      this.handle_show_activebtnPage()
    }
  },
  data() {
    return {
      // immediacy_time: 0
    }
  }
}
</script>
<style scoped>
@import "./styles/activebtnpage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Activebtn.vue